import { render, staticRenderFns } from "./materialManagement.vue?vue&type=template&id=34193ae8&"
import script from "./materialManagement.vue?vue&type=script&lang=js&"
export * from "./materialManagement.vue?vue&type=script&lang=js&"
import style0 from "./materialManagement.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports